import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ValidationHandler } from 'app/helpers/validation.handler';
import { StorageService } from 'app/services/storage.service';
import { finalize } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastService } from 'ng-uikit-pro-standard';
import { Tag } from 'app/models/tag';
import { TagService } from 'app/services/tag.service';
import { EcoDocsTitleService } from 'app/services/ecodocs-title.service';

@Component({
  selector: 'app-add-amazon-storage',
  templateUrl: './add-amazon-storage.component.html',
  styleUrls: ['./add-amazon-storage.component.scss']
})
export class AddAmazonStorageComponent implements OnInit {

  s3Form: FormGroup;
  storageId: number;
  loading: boolean = false;

  isNgSelectLoading: boolean = false;
  
  constructor(private validationHandler: ValidationHandler, private navigateRoute: Router,
    public storageService: StorageService, private formBuilder: FormBuilder,
    private toastService: ToastService, private _route: ActivatedRoute,
    public tagService: TagService, private ecoDocsTitleService: EcoDocsTitleService) {


    //Validate From for Submition 
    this.s3Form = this.storageService.getAmazonS3FormGroup();
    
    //Get FTP driver for edit 
    this._route.params.subscribe(params => {
      if (params.storageid) {
        this.storageId = +params.storageid;
        this.loading = true;
        storageService.getById(this.storageId).pipe(finalize(() => {
          this.loading = false;
        })).subscribe(f => {
          this.s3Form.patchValue(f);
        });
      }
    });
  }

  ngOnInit() {
    this.ecoDocsTitleService.setTitle( 'Add Amazon S3 Storage' , false);
  }

  onAddTag (name: string) {
    this.isNgSelectLoading = true;
    return this.tagService.add(name).pipe(finalize(()=>{
      this.isNgSelectLoading = false;
    })).toPromise();
  }

  showPassword(input) {
    if (input.type == "text") {
      input.type = "password"
    }
    else {
      input.type = "text"
    }
  }
  submit(frm: FormGroup) {
    this.loading = true;

    if (!frm.valid) {
      this.validationHandler.onSubmitCheck(frm);
      this.loading = false;
      return;
    }
    if (this.storageId) {
      this.storageService.updateAmazons3(frm.value).subscribe(t => {
        this.loading = false;
        this.navigateRoute.navigateByUrl('/manage/storage')
      }, err => {
        this.loading = false;
        if (err.status === 422) {
          this.validationHandler.serverValidationHandler(err, frm);

        } else
          this.toastService.error("Save Failed");
      });
    }
    else {
      this.storageService.addAmazons3(frm.value).subscribe(t => {
        this.loading = false;
        this.navigateRoute.navigateByUrl('/manage/storage')
      }, err => {
        this.loading = false;
        if (err.status === 422) {
          this.validationHandler.serverValidationHandler(err, frm);

        } else
          this.toastService.error("Save Failed");

      });
    }
  }

  testConnection(frm: FormGroup) {
    if (!frm.valid) {
      this.validationHandler.onSubmitCheck(frm);
      return;
    }

    this.loading = true;
    this.storageService.amazons3testConnection(frm.value).pipe(finalize(() => {
      this.loading = false;
    })).subscribe(t => {
      this.toastService.success("Connection Succeeded!");
    }, err => {
      if (err.status === 422) {
        this.validationHandler.serverValidationHandler(err, this.s3Form);
      }
      else {
        this.toastService.error("Connection Failed!");
      }
    });
  }
}
